import axios from "../services/api/api";
import { useQuery } from "react-query";

//LICENSEQUERIES
const FetchInvoiceHistoryByEmail = async () => {
  const res = await axios.get(`/Shop/MyOrders`);
  return res.data.result;
};
export function GetInvoiceHistoryByEmail(email) {
  return useQuery(
    ["FetchInvoiceHistoryByEmail", email],
    () => FetchInvoiceHistoryByEmail(email),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

//SCHOOLQUERIES
const FetchSchoolDataBySchoolId = async (schoolId) => {
  const res = await axios.get(`/school/GetSchoolData/${schoolId}`);
  return res.data.result;
};
export function GetSchoolDataBySchoolId(schoolId) {
  return useQuery(
    ["FetchSchoolDataBySchoolId", schoolId],
    () => FetchSchoolDataBySchoolId(schoolId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
      enabled: !!schoolId,
    }
  );
}

//TEACHERQUERIES
const FetchTeacherInformation = async () => {
  var email = localStorage.getItem("email");
  const res = await axios.get(
    `/Teacher/ByEmail?teacherEmail=${encodeURIComponent(email)}`
  );
  if (typeof res !== "undefined") {
    if (res.data.result.programmes && res.data.result.customer) {
      localStorage.setItem("schoolName", res.data.result.customer.name);

      localStorage.setItem("school", JSON.stringify(res.data.result.customer));

      return res.data.result;
    }
    return res;
  }
};
export function GetTeacherInformation(opt = {}) {
  const email = localStorage.getItem("email");

  return useQuery(
    ["FetchTeacherInformation", email],
    () => FetchTeacherInformation(),
    {
      retry: 3,
      refetchOnWindowFocus: false,
      ...opt,
    }
  );
}

const FetchTeacherInfoById = async (teacherId) => {
  const res = await axios.get(`/Teacher/${teacherId}`);
  return res.data.result;
};
export function GetTeacherInfoById(teacherId) {
  return useQuery(["FetchTeacherInfoById", teacherId], () =>
    FetchTeacherInfoById(teacherId)
  );
}

const FetchTeacherCourses = async () => {
  var email = localStorage.getItem("email");
  const res = await axios.get(
    `/Teacher/Courses?email=${encodeURIComponent(email)}`
  );
  if (typeof res !== "undefined") {
    if (res.data.result.programmes) {
      localStorage.setItem("schoolName", res.data.result.customer.name);

      localStorage.setItem("school", JSON.stringify(res.data.result.customer));
    }
    return res.data.result;
  }
};
export function GetTeacherCourses() {
  return useQuery(["FetchTeacherCourses"], () => FetchTeacherCourses());
}

const FetchAvailableModuleAnswers = async () => {
  const res = await axios.get(`/Module/GetAvailableModuleAnswers`);
  return res.data.result;
};

export function GetAvailableModuleAnswers() {
  return useQuery(["FetchAvailableModuleAnswers"], () =>
    FetchAvailableModuleAnswers()
  );
}

//PROGRAMQUERIES
const FetchProgramById = async (programId) => {
  const res = await axios.get(`/programme/${programId}`);
  return res.data.result;
};
export function GetProgramById(programId) {
  return useQuery(
    ["FetchProgramById", programId],
    () => FetchProgramById(programId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchResultsByProgramId = async (programId) => {
  const res = await axios.get(
    `/Course/GetCoursesWithResultsByProgram/${programId}`
  );
  return res.data.result;
};
export function GetResultsByProgramId(programId, opt = {}) {
  return useQuery(
    ["FetchResultsByProgramId", programId],
    () => FetchResultsByProgramId(programId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
      ...opt,
    }
  );
}

//CLASSQUERIES
const FetchClassByClassId = async (classId) => {
  const res = await axios.get(`/Class/GetByClassId/${classId}`);
  return res.data.result;
};
export function GetClassByClassId(classId) {
  return useQuery(
    ["FetchClassByClassId", classId],
    () => FetchClassByClassId(classId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchCoursesByClassId = async (classId) => {
  const res = await axios.get(
    `/Course/GetCoursesWithResultsByClass/${classId}`
  );
  return res.data.result;
};
export function GetCoursesByClassId(classId, opt = {}) {
  return useQuery(
    ["FetchCoursesByClassId", classId],
    () => FetchCoursesByClassId(classId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
      ...opt,
    }
  );
}

const FetchModuleResultsByClassId = async (classId) => {
  const res = await axios.get(
    `/Teacher/ModuleResultsByClassId?classId=${classId}`
  );
  return res.data.result;
};
export function GetModuleResultsByClassId(classId) {
  return useQuery(
    ["FetchModuleResultsByClassId", classId],
    () => FetchModuleResultsByClassId(classId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

//APLQUERIES
const FetchSupervisors = async (schoolId) => {
  const res = await axios.get(
    `/Apl/GetSupervisorsForSchool?schoolId=${schoolId}`
  );
  return res.data.result;
};
export function GetSupervisors(schoolId) {
  return useQuery(
    ["FetchSupervisors", schoolId],
    () => FetchSupervisors(schoolId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchSupervisorCompanies = async () => {
  const res = await axios.get(`/Apl/GetCompanies`);
  return res.data.result;
};
export function GetSupervisorCompanies() {
  return useQuery(
    ["FetchSupervisorCompanies"],
    () => FetchSupervisorCompanies(),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchWorkCards = async () => {
  const res = await axios.get(`/Apl/GetWorkCards`);
  return res.data.result;
};
export function GetWorkCards() {
  return useQuery(["FetchWorkCards"], () => FetchWorkCards(), {
    retry: 3,
    refetchOnWindowFocus: false,
  });
}

const FetchAplAttendancesByStudentId = async (studentId) => {
  const res = await axios.get(
    `/Apl/AttendancesByStudent/?studentId=${studentId}`
  );
  return res.data.result;
};
export function GetAplAttendancesByStudentId(studentId) {
  return useQuery(
    ["FetchAplAttendancesByStudentId", studentId],
    () => FetchAplAttendancesByStudentId(studentId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchAplSupervisorsAndStudentsByPeriodId = async (periodId) => {
  let res = null;
  if (!periodId) {
    return res;
  } else {
    res = await axios.get(
      `/Apl/GetSupervisorsAndStudentsByPeriodId/?periodId=${periodId}`
    );
    return res.data.result;
  }
};
export function GetSupervisorsAndStudentsByPeriodId(periodId) {
  return useQuery(
    ["FetchAplSupervisorsAndStudentsByPeriodId", periodId],
    () => FetchAplSupervisorsAndStudentsByPeriodId(periodId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchAplStudentEvents = async (studentId) => {
  const res = await axios.get(`/Apl/GetStudentEvents/?studentId=${studentId}`);
  return res.data.result;
};
export function GetAplStudentEvents(studentId) {
  return useQuery(
    ["FetchAplStudentEvents", { studentId }],
    () => FetchAplStudentEvents(studentId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchAvailableStudentsForPeriod = async (data) => {
  if (data.candidates.candidateStudentIds.length > 0) {
    const res = await axios.post(
      `/Apl/GetStudentsPossibleToAdd`,
      data.candidates
    );
    return res.data.result;
  } else return [];
};

export function GetAvailableStudentsForPeriod(data) {
  return useQuery(
    ["FetchAvailableStudentsForPeriod", { data }],
    () => FetchAvailableStudentsForPeriod(data),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchPeriods = async (level, id) => {
  let res = { data: { result: null } };
  if (level === "Program") {
    res = await axios.get(`/Apl/GetPeriodsByProgram/?programId=${id}`);
  } else if (level === "Class") {
    res = await axios.get(`/Apl/GetPeriodsByClass/?classId=${id}`);
  } else if (level === "Student") {
    res = await axios.get(`/Apl/GetPeriodsByStudent/?studentId=${id}`);
  }
  return res.data.result;
};

export function GetPeriods(level, id) {
  return useQuery(
    ["FetchPeriods", [level, id]],
    () => FetchPeriods(level, id),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchProgramPeriods = async (id) => {
  let res = { data: { result: null } };
  res = await axios.get(`/Apl/GetPeriodsByProgram/?programId=${id}`);
  return res.data.result;
};

export function GetProgramPeriods(id) {
  return useQuery(
    ["FetchProgramPeriods", [id]],
    () => FetchProgramPeriods(id),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchAttendances = async (level, objId, periodId) => {
  let res = { data: { result: null } };
  if (level === "Program") {
    res = await axios.get(
      `/Apl/AttendancesByProgram/?programId=${objId}&periodId=${periodId}`
    );
  } else if (level === "Class") {
    res = await axios.get(
      `/Apl/AttendancesByClass/?classId=${objId}&periodId=${periodId}`
    );
  } else if (level === "Student") {
    res = await axios.get(`/Apl/AttendancesByStudent/?studentId=${objId}`);
  }
  return res.data.result;
};

export function GetAttendances(level, objId, periodId) {
  return useQuery(
    ["FetchAttendances", [level, objId, periodId]],
    () => FetchAttendances(level, objId, periodId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchEvents = async (level, periodId, objectId) => {
  let res = { data: { result: [] } };
  if (!periodId) {
    return res;
  } else {
    if (level === "Program") {
      res = await axios.get(
        `/Apl/GetStudentEventsProgram?periodId=${periodId}&programId=${objectId}`
      );
    } else if (level === "Class") {
      res = await axios.get(
        `/Apl/GetStudentEventsClass?periodId=${periodId}&classId=${objectId}`
      );
    } else if (level === "Student") {
      res = await axios.get(
        `/Apl/GetStudentEventsStudent?periodId=${periodId}&studentId=${objectId}`
      );
    }
    return res.data.result;
  }
};

export function GetEvents(level, periodId, objectId) {
  return useQuery(
    ["FetchEvents", [level, periodId, objectId]],
    () => FetchEvents(level, periodId, objectId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchWorkCardHours = async (level, periodId, objectId) => {
  let res = null;
  if (!periodId) {
    return res;
  } else {
    if (level === "Program") {
      res = await axios.get(
        `/Apl/GetWorkCardHoursByProgramAndPeriod/?programId=${objectId}&periodId=${periodId}`
      );
    } else if (level === "Class") {
      res = await axios.get(
        `/Apl/GetWorkCardHoursByClassAndPeriod/?classId=${objectId}&periodId=${periodId}`
      );
    } else if (level === "Student") {
      res = await axios.get(
        `/Apl/GetWorkCardHoursByStudentAndPeriod/?studentId=${objectId}&periodId=${periodId}`
      );
    }
    return res.data.result;
  }
};

export function GetWorkCardHours(level, periodId, objectId) {
  return useQuery(
    ["FetchWorkCardHours", [level, periodId, objectId]],
    () => FetchWorkCardHours(level, periodId, objectId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchAttendanceStatuses = async (level, periodId, objectId) => {
  let res = null;
  if (!periodId) {
    return res;
  } else {
    if (level === "Program") {
      res = await axios.get(
        `/Apl/GetAttendanceStatusForProgram/?programId=${objectId}&periodId=${periodId}`
      );
    } else if (level === "Class") {
      res = await axios.get(
        `/Apl/GetAttendanceStatusForClass/?classId=${objectId}&periodId=${periodId}`
      );
    } else if (level === "Student") {
      res = await axios.get(
        `/Apl/GetAttendanceStatusForStudent/?studentId=${objectId}&periodId=${periodId}`
      );
    }
    return res.data.result;
  }
};

export function GetAttendanceStatuses(level, periodId, objectId) {
  return useQuery(
    ["FetchAttendanceStatuses", [level, periodId, objectId]],
    () => FetchAttendanceStatuses(level, periodId, objectId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchFoodCompensationStatus = async (studentId, periodId) => {
  if (periodId) {
    const res = await axios.get(
      `/Apl/GetFoodCompensationRequiredDaysForStudent?studentId=${studentId}&periodId=${periodId}`
    );
    return res.data.result;
  } else return null;
};

export function GetFoodCompensationStatus(studentId, periodId) {
  return useQuery(
    ["FetchFoodCompensationStatus", [studentId, periodId]],
    () => FetchFoodCompensationStatus(studentId, periodId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchEvaluations = async (periodId) => {
  if (periodId) {
    const res = await axios.get(`/Apl/GetEvaluations?periodId=${periodId}`);
    return res.data.result;
  } else return null;
};

export function GetEvaluations(periodId) {
  return useQuery(
    ["FetchEvaluations", periodId],
    () => FetchEvaluations(periodId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchEvaluationQuestions = async (periodId) => {
  if (periodId) {
    const res = await axios.get(
      `/Apl/GetEvaluationQuestions?periodId=${periodId}`
    );
    return res.data.result;
  } else return null;
};

export function GetEvaluationQuestions(periodId) {
  return useQuery(
    ["FetchEvaluationQuestions", periodId],
    () => FetchEvaluationQuestions(periodId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

//STUDENTQUERIES

const FetchStudentInfoByStudentId = async (studentId) => {
  const res = await axios.get("/student/?id=" + studentId);
  return res.data.result;
};
export function GetStudentInfoByStudentId(studentId) {
  return useQuery(
    ["FetchStudentInfoByStudentId", studentId],
    () => FetchStudentInfoByStudentId(studentId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchCoursesByStudentEmail = async (studentEmail) => {
  if (studentEmail !== null) {
    const res = await axios.get(
      "/student/Courses?email=" + encodeURIComponent(studentEmail)
    );
    return res.data.result;
  }
  return null;
};
export function GetCoursesByStudentEmail(studentEmail) {
  return useQuery(
    ["FetchCoursesByStudentEmail", studentEmail],
    () => FetchCoursesByStudentEmail(studentEmail),
    {
      retry: 1,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchCoursesWithResultsByStudentId = async (studentId) => {
  const res = await axios.get(
    `/Course/GetCoursesWithResultsByStudent/${studentId}`
  );
  return res.data.result;
};
export function GetCoursesWithResultsByStudentId(studentId, opt = {}) {
  return useQuery(
    ["FetchCoursesWithResultsByStudentId", studentId],
    () => FetchCoursesWithResultsByStudentId(studentId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
      ...opt,
    }
  );
}

const FetchAverageStudentScoreByStudentId = async (studentId) => {
  const res = await axios.get(
    `/StudentResult/GetAverageScoreDataByStudent/${studentId}`
  );
  return res.data.result;
};
export function GetAverageStudentScoreByStudentId(studentId) {
  return useQuery(
    ["FetchAverageStudentScoreByStudentId", studentId],
    () => FetchAverageStudentScoreByStudentId(studentId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchStudentResultTimelineByStudentId = async (studentId) => {
  const res = await axios.get(
    `/StudentResult/GetStudentResultTimeline/${studentId}`
  );
  return res.data.result;
};
export function GetStudentResultTimelineByStudentId(studentId) {
  return useQuery(
    ["FetchStudentResultTimelineByStudentId", studentId],
    () => FetchStudentResultTimelineByStudentId(studentId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

//RESULTQUERIES
const FetchCourseResultsByCourseId = async (courseId) => {
  if (courseId === null) {
    return null;
  }
  var email = localStorage.getItem("email");
  const res = await axios.get(
    `/Teacher/ModuleResults?teacheremail=${encodeURIComponent(
      email
    )}&courseId=${courseId}`
  );
  return res.data.result;
};
export function GetCourseResultsByCourseId(courseId) {
  return useQuery(
    ["FetchCourseResultsByCourseId", courseId],
    () => FetchCourseResultsByCourseId(courseId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchBestAndLatestStudentResultAnalysisData = async (
  studentId,
  courseId,
  moduleId
) => {
  if (studentId === null || courseId === null || moduleId === null) {
    return null;
  }
  const res = await axios.get(
    `/Teacher/BestAndLatestStudentResultAnalysis?studentId=${studentId}&courseId=${courseId}&moduleId=${moduleId}`
  );
  return res.data.result;
};
export function GetBestAndLatestStudentResultAnalysisData(
  studentId,
  courseId,
  moduleId
) {
  return useQuery(
    [
      "FetchBestAndLatestStudentResultAnalysisData",
      { studentId, courseId, moduleId },
    ],
    () =>
      FetchBestAndLatestStudentResultAnalysisData(
        studentId,
        courseId,
        moduleId
      ),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchBestAndLatestStudentResultAnalysisDataForGy25FinalExamVariant =
  async (studentId, variantId) => {
    if (studentId === null || variantId === null) {
      return null;
    }
    const res = await axios.get(
      `/Teacher/StudentResultAnalysisFinalExam?studentId=${studentId}&variantId=${variantId}`
    );
    return res.data.result;
  };
export function GetBestAndLatestStudentResultAnalysisDataForGy25FinalExamVariant(
  studentId,
  variantId
) {
  return useQuery(
    [
      "FetchBestAndLatestStudentResultAnalysisDataForGy25FinalExamVariant",
      { studentId, variantId },
    ],
    () =>
      FetchBestAndLatestStudentResultAnalysisDataForGy25FinalExamVariant(
        studentId,
        variantId
      ),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchClassResultAnalysisData = async (classId, courseId, moduleId) => {
  if (classId === null || courseId === null || moduleId === null) {
    return null;
  }
  const res = await axios.get(
    `/Teacher/ClassResultAnalysis?classId=${classId}&courseId=${courseId}&moduleId=${moduleId}`
  );
  return res.data.result;
};
export function GetClassResultAnalysisData(classId, courseId, moduleId) {
  return useQuery(
    ["FetchClassResultAnalysisData", { classId, courseId, moduleId }],
    () => FetchClassResultAnalysisData(classId, courseId, moduleId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchFinalExamVariantsForCourse = async (classId, courseId) => {
  if (classId == null || courseId == null) return null;

  const res = await axios.get(
    `/Course/GetFinalExamVariantsForCourse?classId=${classId}&courseId=${courseId}`
  );
  return res.data.result;
};
export function GetFinalExamVariantsForCourse(classId, courseId) {
  return useQuery(
    ["FetchFinalExamVariantsForCourse", classId, courseId],
    () => FetchFinalExamVariantsForCourse(classId, courseId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

//TODO FETCH FOR FINALEXAMVARIANT
const FetchClassResultAnalysisDataGy25FinalExam = async (variantId) => {
  if (variantId === null) {
    return null;
  }
  const res = await axios.get(
    `/Teacher/ClassResultAnalysisFinalExam?finalExamVariantId=${variantId}`
  );
  return res.data.result;
};
export function GetClassResultAnalysisDataGy25FinalExam(variantId) {
  return useQuery(
    ["FetchClassResultAnalysisDataGy25FinalExam", { variantId }],
    () => FetchClassResultAnalysisDataGy25FinalExam(variantId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}
